export const isPasswordValid = (password) => {
  const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{7,}$/;

  const isPasswordValid = passwordRegex.test(password);

  if (!isPasswordValid) {
    return false;
  }

  return true;
};
